import { 
    REQUEST_STATE_GET_REQUEST, REQUEST_STATE_GET_SUCCESS, REQUEST_STATE_GET_ERROR, 
    REQUEST_STATE_GET_BY_KEY_REQUEST, REQUEST_STATE_GET_BY_KEY_SUCCESS, REQUEST_STATE_GET_BY_KEY_ERROR, 
    REQUEST_STATE_ADD_REQUEST, REQUEST_STATE_ADD_SUCCESS, REQUEST_STATE_ADD_ERROR, 
    REQUEST_STATE_EDIT_REQUEST, REQUEST_STATE_EDIT_SUCCESS, REQUEST_STATE_EDIT_ERROR, 
    REQUEST_STATE_DELETE_REQUEST, REQUEST_STATE_DELETE_SUCCESS, REQUEST_STATE_DELETE_ERROR
} from "../constants/requestStateConstants";

const initialState = {
    requestStates: [],
    requestState: {},
    loading: false,
    success: null,
    error: null,
    requestStateRequestedCount: 0,
};

export const requestStateReducer = (state = initialState, action) => {
    switch (action.type)     {
        case REQUEST_STATE_GET_REQUEST:
            return {
                ...state,
                requestStateRequestedCount: ++state.requestStateRequestedCount,
                loading: true,
            };
        case REQUEST_STATE_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                requestStates: action.payload,
                success: true,
            };
        case REQUEST_STATE_GET_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case REQUEST_STATE_GET_BY_KEY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REQUEST_STATE_GET_BY_KEY_SUCCESS:
            return {
                ...state,
                loading: false,
                requestState: action.payload,
                success: true,
            };
        case REQUEST_STATE_GET_BY_KEY_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case REQUEST_STATE_ADD_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REQUEST_STATE_ADD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case REQUEST_STATE_ADD_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case REQUEST_STATE_EDIT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REQUEST_STATE_EDIT_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case REQUEST_STATE_EDIT_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case REQUEST_STATE_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REQUEST_STATE_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case REQUEST_STATE_DELETE_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        default:
            return state;
    }
}
